import { normalizeCountryCode } from '@shared/core/localized-defaults'
import { type CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js'

export type CountryOption = {
  value: CountryCode
  label: string
}

export function formatCountryName(countryCode: string | null | undefined): string | null {
  const code = normalizeCountryCode(countryCode)
  if (!code) return null
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' }).of(code) ?? code
  } catch {
    return code
  }
}

export function buildCountryOptions(): CountryOption[] {
  return getCountries()
    .map((code) => ({ value: code, label: `${formatCountryName(code)} (+${getCountryCallingCode(code)})` }))
    .sort((a, b) => a.label.localeCompare(b.label, 'en'))
}
